<template>
  <div>
    <b-form-group label="CEP:">
      <b-form-input
        v-model="zip_code"
        placeholder="CEP"
        :state="validateState('zip_code')"
      ></b-form-input>
      <b-form-invalid-feedback>
        <span v-if="!$v.address.zip_code.required"
          >O CEP é um campo obrigatório.</span
        >
        <span v-if="!$v.address.zip_code.minLength"
          >O campo CEP requer um mínimo de 8 caracteres.</span
        >
        <span v-if="!$v.address.zip_code.maxLength"
          >O campo CEP requer um máximo de 8 caracteres.</span
        >
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Rua:">
      <b-form-input
        v-model="address.street"
        placeholder="Rua"
        :state="validateState('street')"
      ></b-form-input>
      <b-form-invalid-feedback
        >Rua é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="Número:">
      <b-form-input
        v-model="address.number"
        :state="validateState('number')"
        placeholder="Número"
      ></b-form-input>
      <b-form-invalid-feedback
        >Número é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="Bairro:">
      <b-form-input
        v-model="address.neighborhood"
        :state="validateState('neighborhood')"
        placeholder="Bairro"
      ></b-form-input>
      <b-form-invalid-feedback
        >Bairro é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="Complemento:">
      <b-form-input
        v-model="address.complement"
        placeholder="Complemento"
      ></b-form-input>
    </b-form-group>

    <b-form-group label="Cidade:">
      <Cidade
        v-model="address.county_id"
        :state="validateState('county_id')"
      ></Cidade>
      <b-form-invalid-feedback
        >Cidade é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>
  </div>
</template>

<script>
import Cidade from "@/modules/counties/Components/Cidade.vue";
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  components: { Cidade },
  props: {},
  mixins: [validationMixin],
  data: () => ({}),
  validations: {
    address: {
      zip_code: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(8),
      },
      street: {
        required,
      },
      number: {
        required,
      },
      neighborhood: {
        required,
      },
      county_id: {
        required,
      },
    },
  },
  computed: {
    ...mapState("legal_people", ["legal_person"]),
    address() {
      return this.legal_person.address;
    },
    zip_code: {
      set(value) {
        value = value.replace(/\D/g, "").substring(0, 8);
        this.address.zip_code = value;
      },
      get() {
        let value = this.address.zip_code.replace(
          /^(\d{2})(\d{3})(\d{3})/,
          "$1.$2-$3"
        );
        return value;
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.address[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.address.$touch();
      return !this.$v.address.$anyError;
    },
  },

  watch: {
    zip_code: function (value) {
      let cep = value.replace(/\D/g, "");
      let url = `https://viacep.com.br/ws/${cep}/json/`;
      if (cep) {
        var validaCep = /^[0-9]{8}$/;
        if (validaCep.test(cep)) {
          fetch(url)
            .then((response) => response.json())
            .then((response) => {
              (this.address.cep = response.cep),
                (this.address.street = response.logradouro),
                (this.address.neighborhood = response.bairro),
                (this.address.county_id = response.ibge);
              this.address.complement = response.complemento;
            })
            .catch((error) => console.log(error));
        }
      }
    },
  },
  created() {},
};
</script>
